function Title({ name, className = '' }) {
    return (
        <h1 className={"flex flex-col items-center text-[35px] lg:text-[40px] font-[GothamMedium] tracking-wider " + className}>
            <span className="text-center">{name}</span>
            <div className="w-[80%] h-2 bg-[#51bdeb3c]"></div>
        </h1>
    );
}

export default Title;